import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { CartProvider } from "./context/CartContext";
import { AuthProvider } from "./context/AuthContext";
import { CustomerAuthProvider } from "./context/CustomerAuthContext";
import { RatingsProvider } from "./context/RatingsContext";
import { WishlistProvider } from "./context/WishlistContext";
import { RecentlyViewedProvider } from "./context/RecentlyViewedContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import CartDrawer from "./components/CartDrawer";
import { BalmartToaster } from "./components/BalmartToaster";
import NewsletterPopup from "./components/NewsletterPopup";
import WhatsAppButton from "./components/WhatsAppButton";
import HomePage from "./pages/HomePage";
import ShopPage from "./pages/ShopPage";
import ProductDetailPage from "./pages/ProductDetailPage";
import RoutinePage from "./pages/RoutinePage";
import AboutPage from "./pages/AboutPage";
import CartPage from "./pages/CartPage";
import ContactPage from "./pages/ContactPage";
import AdminLoginPage from "./pages/AdminLoginPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import AccountPage from "./pages/AccountPage";
import WishlistPage from "./pages/WishlistPage";
import ReferralPage from "./pages/ReferralPage";
import AuthCallback from "./pages/AuthCallback";
import Dashboard from "./pages/Dashboard";
import PaymentSuccessPage from "./pages/PaymentSuccessPage";
import PaymentCancelledPage from "./pages/PaymentCancelledPage";
import OrderTrackingPage from "./pages/OrderTrackingPage";

function AppContent() {
  const location = useLocation();

  // Check for session_id in hash - handle auth callback synchronously before routes render
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  const isDashboard = location.pathname.startsWith('/dashboard');
  const isAdminLogin = location.pathname === '/admin' || location.pathname === '/admin-login';
  const hideShell = isDashboard || isAdminLogin;

  return (
    <>
      {!hideShell && <Navbar />}
      {!hideShell && <CartDrawer />}
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/shop" element={<ShopPage />} />
        <Route path="/product/:id" element={<ProductDetailPage />} />
        <Route path="/routine" element={<RoutinePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/cart" element={<CartPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/account" element={<AccountPage />} />
        <Route path="/wishlist" element={<WishlistPage />} />
        <Route path="/referral" element={<ReferralPage />} />
        <Route path="/admin" element={<AdminLoginPage />} />
        <Route path="/admin-login" element={<AdminLoginPage />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/payment-success" element={<PaymentSuccessPage />} />
        <Route path="/payment-cancelled" element={<PaymentCancelledPage />} />
        <Route path="/order/:orderId" element={<OrderTrackingPage />} />
      </Routes>
      {!hideShell && <Footer />}
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CustomerAuthProvider>
          <CartProvider>
            <RatingsProvider>
              <WishlistProvider>
                <RecentlyViewedProvider>
                  <AppContent />
                  <NewsletterPopup />
                  <WhatsAppButton />
                  <BalmartToaster />
                </RecentlyViewedProvider>
              </WishlistProvider>
            </RatingsProvider>
          </CartProvider>
        </CustomerAuthProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
